/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from "../ApiClient";

/**
* AQAStripeController service.
* @module api/AQAStripeControllerApi
* @version v0
*/
export default class AQAStripeControllerApi {

    /**
    * Constructs a new AQAStripeControllerApi. 
    * @alias module:api/AQAStripeControllerApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instanc
    e} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }

    /**
     * Callback function to receive the result of the stripe operation.
     * @callback moduleapi/AQAStripeControllerApi~stripeCallback
     * @param {String} error Error message, if any.
     * @param {'String'{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Stripe entry point
     * @param {String} body 
     * @param {String} stripeSignature 
     * @param {module:api/AQAStripeControllerApi~stripeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    stripe(body, stripeSignature, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling stripe");
      }
      // verify the required parameter 'stripeSignature' is set
      if (stripeSignature === undefined || stripeSignature === null) {
        throw new Error("Missing the required parameter 'stripeSignature' when calling stripe");
      }

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        'Stripe-Signature': stripeSignature
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let accepts = ['text/plain;charset=UTF-8', 'text/plain; charset=UTF-8'];
      let returnType = 'String';

      return this.apiClient.callApi(
        '/stripe', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

}